import * as api from '../../services/exchange_rate/api_exchange_rate';
import * as apiCommon from '../../services/apiCommon';
import { browserHistory } from 'react-router';
import { delay, call, put, select, takeEvery, takeLatest } from 'redux-saga/effects';
import * as common from '../sagasCommon';
import * as DocType from '../../constants/constant_doc_types';


export function* fetchListExchangeRateSaga(feathersApp) {
    yield takeLatest('FETCH_LIST_EXCHANGE_RATE', callFetchListExchangeRate, feathersApp);
}

function* callFetchListExchangeRate(feathersApp, action) {
    const { filters, silent } = action;
    yield common.showProgressListTable(silent);
    try {
        const dataParams = {
            filters,
            list_type: 'exchange_rate'
        };
        const tableData = yield call(apiCommon.getDocs, feathersApp, dataParams);
        yield call(common.doneListTable, { rows: tableData.data, total_rows: tableData.total });
    } catch (error) {
        yield common.showErrorListTable(error);
    }
}


export function* saveExchangeRateSaga(feathersApp) {
    yield takeEvery("SAVE_EXCHANGE_RATE", callSaveExchangeRate, feathersApp);
}

function* callSaveExchangeRate(feathersApp, action) {
    const { tenant, user, silent } = yield select();
    try {
        yield common.showProgressSaveRecord(silent);

        const params = { tenant, user, data: action.data };
        let result = yield call(api.saveExchangeRate, feathersApp, params);

        const id = result && result.id;
        if (id) {
            yield callFetchExchangeRateForEdit(feathersApp, { id, silent: true });
            browserHistory.push(`/admin/exchange_rate/edit/${id}`);
            yield common.doneSaveRecord(result, 'Exchange rate was saved');
        } else {
            yield common.showErrorSaveRecord(new Error('Error in saving : Exhange Rate'));
        }
    } catch (error) {
        yield common.showErrorSaveRecord(error);
    }
}

export function* deleteExchangeRateSaga(feathersApp) {
    yield takeEvery('DELETE_EXCHANGE_RATE', callDeleteExchangeRate, feathersApp);
}

function* callDeleteExchangeRate(feathersApp, action) {
    yield put({ type: 'DELETE_RECORD_INPROGRESS' });
    try {
        const { id } = action;
        if (id) {
            const state = yield select();
            const { tenant, user } = state;
            const { id } = action;
            const params = { tenant, user, id };
            yield call(api.deleteExchangeRate, feathersApp, params);
        }
        yield put({ type: "DELETE_RECORD_DONE", payload: { id, docType: DocType.EXCHANGE_RATE } });
        yield delay(2000);
        browserHistory.push('/admin/exchange_rate');
        

    } catch (error) {
        yield put({ type: 'DELETE_RECORD_ERROR', error })
    }
}

export function* fetchExchangeRateForEditSaga(feathersApp) {
    yield takeEvery('FETCH_EXCHANGE_RATE_FOR_EDIT', callFetchExchangeRateForEdit, feathersApp);
}

function* callFetchExchangeRateForEdit(feathersApp, action) {
    const { tenant, user } = yield select();
    const { id, silent } = action;

    try {
        if (id) {
            yield common.showProgressDataById(silent);
            const fetchParams = { tenant, user, id };
            const doc = yield call(api.fetchExchangeRateById, feathersApp, fetchParams);
            yield common.doneDataById(doc);
        }
    } catch (error) {
        yield put({ type: "FETCH_DATA_BY_ID_ERROR", error: error });
    }
}
